import { useIsAgentsModuleEnabled } from "src/hooks/useIsAgentsModuleEnabled";
import { useIsFeatureFlagEnabled } from "src/hooks/useIsFeatureFlagEnabled";
import { useIsMcpServerEnabled } from "src/hooks/useIsMcpServerEnabled";
import { FEATURE_FLAGS } from "src/router/featureFlags";
import { useCurrentUserId } from "src/store/AuthStore";

/**
 * Whether the unified copilot mounts on the current workspace.
 *
 * Single source of truth for the providers, the `/copilot` route and the nav
 * item: the copilot page's hooks throw without the providers, so everything
 * that leads to the page has to agree with what mounts them.
 */
export const useIsUnifiedCopilotEnabled = (): { isEnabled: boolean } => {
  const isFlagEnabled = useIsFeatureFlagEnabled(FEATURE_FLAGS.unifiedCopilot);
  // The copilot runs on the agents module and declares the workspace's own MCP
  // server as a tool source on every session, so on a workspace missing either
  // one the launcher opens a session that cannot answer.
  const { isEnabled: isAgentsModuleEnabled } = useIsAgentsModuleEnabled();
  const { isEnabled: isMcpServerEnabled } = useIsMcpServerEnabled();
  // Sessions and display preferences are scoped to the signed-in user.
  const userId = useCurrentUserId();

  return {
    isEnabled:
      isFlagEnabled &&
      isAgentsModuleEnabled &&
      isMcpServerEnabled &&
      userId !== undefined,
  };
};
